import DateMaster from './date_master';

export default class AccountMapper {
  static map(userData) {
    return {
      email: userData.email,
      name: userData.name,
      headline: userData.headline,
      confirmed: userData.confirmed,
      pauseAll: userData.pause_all,
      createdAt: DateMaster.parseUTC(userData.created_at),
      updatedAt: DateMaster.parseUTC(userData.updated_at),
      tacksCount: userData.tacks_count,
      finishedTacksCount: userData.finished_tacks_count,
      activeTacksCount: userData.active_tacks_count,
      queuedTacksCount: userData.queued_tacks_count,
      slug: userData.slug,
      followersCount: userData.followers_count,
      followsCount: userData.follows_count,
      public: userData.public,
      points: userData.points,
      hasActiveMobileDevice: userData.has_active_mobile_device
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/utils/account_mapper.js